import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Editor, Toolbar } from 'ngx-editor';
import { OtherInformationSection } from 'src/app/shared/models/data/documentTemplate';
import { createDocumentEditor, DOCUMENT_TEMPLATE_TOOLBAR } from 'src/app/shared/ngx-editor/document-template-editor';

@Component({
  selector: 'app-other-information-section',
  templateUrl: './other-information-section.component.html',
  styleUrls: ['./other-information-section.component.scss'],

})
export class OtherInformationSectionComponent implements OnInit, OnDestroy {
  @Input() reset!: () => void;
  @Input() theme: string = "silver";
  @Input() isMobile: boolean = false;
  @Input() otherInformation: OtherInformationSection = { sections: [], bottomSection: { isModified: false, value: '' } };
  @Output() otherInformationChange = new EventEmitter<OtherInformationSection>();


  constructor(private translate: TranslateService) {

  }

  freeTextEditor: Editor = createDocumentEditor();
  editors: Editor[] = [];
  toolbar: Toolbar = DOCUMENT_TEMPLATE_TOOLBAR;

  ngOnInit(): void {
    this.initializeEditors();
  }

  ngOnDestroy(): void {
    this.editors.forEach(editor => editor.destroy());
  }

  initializeEditors(): void {
    this.editors = this.otherInformation.sections.map(() => createDocumentEditor());
  }

  addSection() {
    this.otherInformation.sections.push({ title: '', value: '' });
    this.editors.push(createDocumentEditor()); // Add a new Editor instance for the new section
    this.otherInformationChange.emit(this.otherInformation);
  }

  removeSection(index: number) {
    this.otherInformation.sections.splice(index, 1);
    this.editors[index].destroy(); // Destroy the editor instance
    this.editors.splice(index, 1); // Remove the editor instance from the array
    this.otherInformationChange.emit(this.otherInformation);
  }

  updateSectionTitle(index: number, title: string) {
    this.otherInformation.sections[index].title = title;
    this.otherInformationChange.emit(this.otherInformation);
  }

  updateSectionValue(index: number, value: string) {
    this.otherInformation.sections[index].value = value;
    this.otherInformationChange.emit(this.otherInformation);
  }

  onBottomSectionChange(newValue: string) {
    this.otherInformation.bottomSection.value = newValue;
    this.otherInformation.bottomSection.isModified = true;
    this.otherInformationChange.emit(this.otherInformation);
  }

}
